// All available roles. Higher roles inherit all privileges of lower roles.
// Hierarchy (lowest to highest): Client < Basic < TeamLeader < Admin = Developer
// Pipeline is a special non-hierarchical role for automated processes.

const Roles = {
    Client: "client",
    Basic: "basic",
    TeamLeader: "team_leader",
    Admin: "admin",
    Developer: "developer",
    Pipeline: "pipeline",
};

export const ROLE_LABELS = {
    [Roles.Client]: "Client",
    [Roles.Basic]: "Staff",
    [Roles.TeamLeader]: "Team Leader",
    [Roles.Admin]: "Admin",
    [Roles.Developer]: "Developer",
    [Roles.Pipeline]: "Pipeline",
};

export const roleLabel = function (role) {
    return ROLE_LABELS[role] ?? role;
};

export default Roles;
